export interface InputOptions {
  label?: string;
  placeholder?: string;
  minHeight?: number;
  isRequired?: boolean;
  isError?: boolean;
  errorMessage?: string;
  isDisabled?: boolean;
  maxLength?: number;
  errorState?: ErrorState
};


export enum ErrorState {
  default = "default",
  focusOut = "focusOut"
}
